<sw-page class="tdar-availability-request-detail">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataAvailabilityRequestSW6.module.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button @click="setStatus('done')">
            {{ $tc('TopdataAvailabilityRequestSW6.admin.markDone') }}
        </sw-button>
        <sw-button @click="setStatus('spam')">
            {{ $tc('TopdataAvailabilityRequestSW6.admin.markSpam') }}
        </sw-button>
        <sw-button variant="primary" @click="$router.push({ name: 'tdar.availability.request.list' })">
            {{ $tc('global.default.back') }}
        </sw-button>
        <sw-button variant="danger" @click="onDelete">
            {{ $tc('TopdataAvailabilityRequestSW6.admin.delete') }}
        </sw-button>
    </template>

    <template #content>
        <sw-card-view v-if="item">
            <sw-card :title="$tc('TopdataAvailabilityRequestSW6.module.title')">
                <sw-description-list>
                    <dt>{{ $tc('TopdataAvailabilityRequestSW6.admin.productNumber') }}</dt>
                    <dd>{{ item.productNumber }}</dd>

                    <dt>{{ $tc('TopdataAvailabilityRequestSW6.admin.productName') }}</dt>
                    <dd>{{ item.productName }}</dd>

                    <dt>{{ $tc('TopdataAvailabilityRequestSW6.admin.email') }}</dt>
                    <dd>{{ item.email }}</dd>

                    <dt>{{ $tc('TopdataAvailabilityRequestSW6.admin.customerNumber') }}</dt>
                    <dd>{{ item.customerNumber || '-' }}</dd>

                    <dt>{{ $tc('TopdataAvailabilityRequestSW6.admin.ip') }}</dt>
                    <dd>{{ item.ipAddress || '-' }}</dd>

                    <dt>{{ $tc('TopdataAvailabilityRequestSW6.admin.status') }}</dt>
                    <dd>
                        <sw-badge :variant="statusVariant(item.status)">
                            {{ statusLabel(item.status) }}
                        </sw-badge>
                    </dd>

                    <dt>{{ $tc('TopdataAvailabilityRequestSW6.admin.createdAt') }}</dt>
                    <dd>
                        <sw-time-ago
                            :date="item.createdAt"
                            :date-time-format="{ month: '2-digit', day: '2-digit' }"
                        />
                    </dd>
                </sw-description-list>

                <div class="tdar-availability-request-detail__message">
                    <dt>{{ $tc('TopdataAvailabilityRequestSW6.admin.message') }}</dt>
                    <pre>{{ item.message || '-' }}</pre>
                </div>
            </sw-card>
        </sw-card-view>

        <sw-loader v-else-if="isLoading" />

        <sw-empty-state
            v-else
            :title="$tc('TopdataAvailabilityRequestSW6.admin.notFound')"
        />

        <sw-confirm-modal
            v-if="showDeleteModal"
            type="delete"
            :title="$tc('TopdataAvailabilityRequestSW6.admin.delete')"
            :text="$tc('TopdataAvailabilityRequestSW6.admin.deleteConfirmText')"
            @confirm="onConfirmDelete"
            @close="onCloseDeleteModal"
            @cancel="onCloseDeleteModal"
        />
    </template>
</sw-page>
